var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 57.8100 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88281-35.2539C4.88281-34.1797 5.32227-33.2031 6.10352-32.373L36.2793-2.39258C37.0117-1.61133 38.0371-1.2207 39.1602-1.2207C41.4551-1.2207 43.1641-2.92969 43.1641-5.22461C43.1641-6.34766 42.7246-7.32422 41.9922-8.10547L14.7461-35.2539L41.9922-62.4023C42.7246-63.1836 43.1641-64.209 43.1641-65.2832C43.1641-67.5781 41.4551-69.2871 39.1602-69.2871C38.0371-69.2871 37.0117-68.8965 36.2793-68.1152L6.10352-38.1348C5.32227-37.3047 4.88281-36.3281 4.88281-35.2539Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleft);
export default __webpack_public_path__ + "static/media/chevron.left.5b82e7f5df9fd845686b5cd92bfd634c.svg";
export { ForwardRef as ReactComponent };